import type { Schemas } from '@crm/contracts';

const HEX = /^#[0-9a-f]{6}$/i;

function darken(hex: string, amount = 0.25): string {
  const n = parseInt(hex.slice(1), 16);
  const c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => Math.round(v * (1 - amount)));
  return '#' + c.map((v) => v.toString(16).padStart(2, '0')).join('');
}

/** Applique l'habillage de l'entreprise (réglage en base). Sans réglage : couleurs du produit. */
export function applyTheme(theme: Schemas['Theme'] | undefined): void {
  const root = document.documentElement.style;
  const primary = theme?.primary_color && HEX.test(theme.primary_color) ? theme.primary_color : null;
  const accent = theme?.accent_color && HEX.test(theme.accent_color) ? theme.accent_color : null;
  if (primary) {
    root.setProperty('--color-brand', primary);
    root.setProperty('--color-brand-dark', darken(primary));
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', primary);
  } else {
    root.removeProperty('--color-brand');
    root.removeProperty('--color-brand-dark');
  }
  if (accent) root.setProperty('--color-accent', accent);
  else root.removeProperty('--color-accent');
  document.title = theme?.product_name || 'CRM Agro';
}
